import React, { useEffect, useRef } from 'react';
import './VideoSection.css';

const VideoSection = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const cvs = canvasRef.current;
        if (!cvs) return;
        const ctx = cvs.getContext('2d');
        let W, H, t = 0;

        const NODES = 70;
        let nodes = [];
        let animationFrameId;

        const resize = () => {
            W = cvs.width = cvs.offsetWidth;
            H = cvs.height = cvs.offsetHeight;
            // Creamos los nodos aleatorios en la pantalla
            nodes = Array.from({length: NODES}, () => ({
                x: Math.random() * W, y: Math.random() * H,
                vx: (Math.random() - 0.5) * 0.5,
                vy: (Math.random() - 0.5) * 0.5,
                r: 1 + Math.random() * 2,
                pulse: Math.random() * Math.PI * 2
            }));
        };

        const draw = () => {
            t += 0.008;
            ctx.clearRect(0, 0, W, H);

            /* --- 1. Fondo Degradado Base --- */
            const bg = ctx.createLinearGradient(0, 0, W, H);
            bg.addColorStop(0,   '#060638');
            bg.addColorStop(0.5, '#0A0A6E');
            bg.addColorStop(1,   '#04042A');
            ctx.fillStyle = bg;
            ctx.fillRect(0, 0, W, H);

            /* --- 2. Cuadrícula en movimiento --- */
            ctx.strokeStyle = 'rgba(60,84,255,0.10)';
            ctx.lineWidth = 1;
            const gridSize = 80;
            const offset = (t * 20) % gridSize;
            for (let x = -gridSize + offset; x < W + gridSize; x += gridSize) {
                ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, H); ctx.stroke();
            }
            for (let y = -gridSize + offset; y < H + gridSize; y += gridSize) {
                ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(W, y); ctx.stroke();
            }

            /* --- 3. Luces Radiales (Glow) --- */
            const g1 = ctx.createRadialGradient(W*0.15, H*0.3, 0, W*0.15, H*0.3, W*0.45);
            g1.addColorStop(0, 'rgba(40,64,255,0.20)');
            g1.addColorStop(1, 'rgba(40,64,255,0)');
            ctx.fillStyle = g1; ctx.fillRect(0,0,W,H);

            const g2 = ctx.createRadialGradient(W*0.85, H*0.7, 0, W*0.85, H*0.7, W*0.4);
            g2.addColorStop(0, 'rgba(16,34,200,0.18)');
            g2.addColorStop(1, 'rgba(16,34,200,0)');
            ctx.fillStyle = g2; ctx.fillRect(0,0,W,H);

            /* --- 4. Red de Nodos (Conexiones IA) --- */
            nodes.forEach(n => {
                n.x += n.vx; n.y += n.vy;
                if (n.x < -10) n.x = W + 10;
                if (n.x > W+10) n.x = -10;
                if (n.y < -10) n.y = H + 10;
                if (n.y > H+10) n.y = -10;
                n.pulse += 0.02;

                const alpha = 0.2 + 0.15 * Math.sin(n.pulse);
                ctx.beginPath();
                ctx.arc(n.x, n.y, n.r, 0, Math.PI * 2);
                ctx.fillStyle = `rgba(255,255,255,${alpha})`;
                ctx.fill();
            });

            /* Trazar líneas entre nodos cercanos */
            for (let i = 0; i < nodes.length; i++) {
                for (let j = i + 1; j < nodes.length; j++) {
                    const a = nodes[i], b = nodes[j];
                    const d = Math.hypot(a.x - b.x, a.y - b.y);
                    if (d < 130) {
                        const alpha = 0.07 * (1 - d / 130);
                        ctx.beginPath();
                        ctx.moveTo(a.x, a.y);
                        ctx.lineTo(b.x, b.y);
                        ctx.strokeStyle = `rgba(70,96,255,${alpha * 3})`;
                        ctx.lineWidth = 0.8;
                        ctx.stroke();
                        ctx.strokeStyle = `rgba(255,255,255,${alpha})`;
                        ctx.stroke();
                    }
                }
            }

            animationFrameId = requestAnimationFrame(draw);
        };

        window.addEventListener('resize', resize);
        resize();
        draw();

        // Limpieza del efecto al desmontar el componente
        return () => {
            window.removeEventListener('resize', resize);
            cancelAnimationFrame(animationFrameId);
        };
    }, []);

    return (
        <section className="hero" id="home">
            <canvas id="heroCvs" ref={canvasRef}></canvas>
            <div className="hero-overlay"></div>

            <div className="hero-inner">
                <h1 className="hero-title">Tu camino hacia la industria inteligente</h1>
                <a
                    className="hero-cta"
                    href="https://wa.me/34624118531?text=%C2%A1Hola%20Me%20interesa%20conocer%20m%C3%A1s%20sobre%20c%C3%B3mo%20Navi%20puede%20ayudarme%20a%20digitalizar%20y%20optimizar%20mis%20procesos%20automáticos."
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    EMPIEZA AQUÍ
                </a>
            </div>
        </section>
    );
};

export default VideoSection;